import { Component, OnInit, ViewChild, ElementRef, Input, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup } from '@angular/forms';
import * as FileSaver from 'file-saver';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionStatusPopupComponent } from 'src/app/Shared/action-status-popup/action-status-popup.component';
import { ApplicationActivityStore } from 'src/common/commonFunction';
import { ApplicationActivityService } from 'src/Services/application-activity.service';
import { CheckAuth } from 'src/Services/utility.service';
import { AppConfig } from 'src/Services/app.config';
import { ActionActivity, ToolEnum } from 'src/Models/Common';
import { IPCSupdatesModel, IPCSupdatesPageModel } from 'src/Models/FrontIPCSModel';
import { HtmlToPdf } from 'src/Services/htmlToPdf';
import { FrontIPCSService } from 'src/Services/FrontIPCSService';

import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-ipcs-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.css']
})
export class IPCSUpdateComponent implements OnInit {
  userID: number = 0;
  isAscending: boolean;
  statusCode: number = 0;
  appModel: any;

  upDowUpdateCategoryNameCSS: string = '';
  upDowStateCSS: string = '';
  upDowUpdateTypeCSS: string = '';
  upDowCreatedByCSS: string = '';
  upDowCreatedDateCSS: string = '';
  upDowModifiedByCSS: string = '';
  upDowModifiedDateCSS: string = '';
  upDowUpdateDateCSS: string = '';

  isloading: boolean = false;
  tokenKey: string = '';
  updatesModel: IPCSupdatesModel[] = [];
  isRecords: boolean = false;
  isShowprogressSpinner: boolean;
  blockedDocument: boolean = false;
  totalRecordsCount: number = -1;
  deleteupdateId: number = 0;
  @ViewChild('deletecloseBtn', { static: false }) deletecloseBtn: ElementRef;
  queryParams: string = '';
  updatesForm: FormGroup;
  totalunread: number = 0;
  alldata: string = 'all';
  unreaddata: string = 'unread';
  parameterModel = new IPCSupdatesPageModel();
  baseUrl: string;

  //State List
  dropdownListState = [];
  selectedItemsState = [];
  dropdownSettingsState = {};
  stateFilter: string = '';

  listOfstateID: string[] = [];
  ClientSelectedTool: string;
  productId: number = 0;

  //isActionItemSubscription: boolean = false;

  rangeOfupdatesDates: any;
  ipcsUnreadflag:boolean=true;
  ipcsUnread: number = 0;
  isDisplayAllData:boolean=false;

  constructor(private readonly modalService: NgbModal, 
    @Inject('BASE_URL') baseUrl: string, 
    private readonly htmlToPdf: HtmlToPdf,
    private readonly ipcsService: FrontIPCSService, 
    private readonly toastr: ToastrService,
    private readonly titleService: Title, 
    private readonly checkAuth: CheckAuth,
    private readonly router: Router, 
    private readonly activedRoute: ActivatedRoute, 
    private readonly appActivity: ApplicationActivityService,
    private sessionStorageService: SessionStorageService) {
    this.baseUrl = baseUrl;
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.userID = +sessionStorage.getItem('UserId');
    this.appModel = AppConfig.settings.ConnectionStrings;

    this.ClientSelectedTool = "ipcs";

    this.productId = ToolEnum.ipcs;
    this.titleService.setTitle('Updates | JSi360');

    // Try to get token
    this.waitForTokenThenInit();
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  private waitForTokenThenInit(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();

    if (!this.tokenKey) {
      console.warn('Token is empty, retrying in 100ms...');
      const interval = setInterval(() => {
        this.tokenKey = this.sessionStorageService.getTokenValue();
        if (this.tokenKey) {
          clearInterval(interval);
          this.afterTokenReady();
        }
      }, 100); // check every 100ms
    } else {
      this.afterTokenReady();
    }
  }

  /** Call what you normally do in ngOnInit */
  private afterTokenReady(): void {
    let ipcsReadflag = sessionStorage.getItem('ipcsUnreadflag');
    this.ipcsUnreadflag = ipcsReadflag === 'true' ? true : false;

    let ipcsUnreadcount = sessionStorage.getItem('ipcsUnread');

    this.ipcsUnread = parseInt(ipcsUnreadcount);

    this.movetotop();
    this.parameterModel.pageIndex = 1;
    this.parameterModel.pageSize = 10;
    this.parameterModel.keywordFilter = 'null';
    this.parameterModel.whereCondition = 'null';
    this.parameterModel.orderBy = 'UpdateDate desc';
    this.upDowUpdateDateCSS = 'active';
    this.isAscending = true;
    this.parameterModel.fromupdatesDateFilter = "null";
    this.parameterModel.toupdatesDateFilter = "null";
    this.parameterModel.userID = this.userID.toString();
    this.parameterModel.updatetype = "1,2";
    this.isloading = true;
    this.GetUpdates();
    this.GetStateData();
  }

  ngOnInit() {
    
    //this.clientHasActionItemSubscription();
  }

  // clientHasActionItemSubscription() {
  //   let clientToolAccess = sessionStorage.getItem('ClientAccessibleTools');
  //   if (clientToolAccess != null && clientToolAccess != '') {
  //     let arraySubscription = clientToolAccess.split(',');
  //     if (arraySubscription.length > 0) {
  //       let tmpAction = ToolEnum[ToolEnum.ipcs];
  //       let coun = arraySubscription.filter(m => m === tmpAction);
  //       if (coun.length > 0)
  //         this.isActionItemSubscription = true;
  //       else
  //         this.isActionItemSubscription = false;
  //     }
  //   }
  // }

  GetUpdates(): void {
    if (this.ipcsUnread > 0) {
      this.parameterModel.unreadonly = "1";
      this.isDisplayAllData=false;
    }
    else {
      this.parameterModel.unreadonly = "0";
      this.isDisplayAllData=true;
    }

    this.ipcsService.getIPCSupdatesfindByUserID(this.tokenKey, this.parameterModel).subscribe(
      data => {
        this.isloading = false;
        if (data["status"] == "Success") {
          sessionStorage.setItem('ipcsUnreadflag', 'true');
          this.ipcsUnreadflag = true;

          this.updatesModel = data["updates"];
          if (this.updatesModel.length > 0) {
            this.isRecords = true;
            this.totalRecordsCount = parseInt(this.updatesModel[0].totalRecordCount);
            if (this.ipcsUnread>0) {
              this.saveNotification(this.updatesModel);
            }
          }
          else {
            this.totalRecordsCount = 0;
            this.isRecords = false;
          }
        }
        else {
          this.showMessage('There is an issue while fetching data. Please try again.', 'Error', 'error');
        }
      },
      error => {
        this.statusCode = error
      },
    );
  }

  ActiveInactiveUpdates(updateId: any, isactive: any) {
    this.blockDocument();
    this.ipcsService.ActiveinactiveIPCSupdates(this.tokenKey, updateId, isactive)
      .subscribe(data => {
        if (data["status"] == "Success") {
          if (isactive) {
            this.showMessage('Activated successfully', 'Active', 'success');
          }
          else {
            this.showMessage('Inactivated successfully', 'Inactive', 'success');
          }
          this.GetUpdates();
        }
        else {
          this.showMessage(data["status"], 'Error', 'error');
        }
        this.unblockDocument();
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  sort(sortBy: string) {
    if (!this.isAscending) {
      this.isAscending = true;
      this.parameterModel.orderBy = sortBy + ' DESC';

      if (sortBy === "UpdateCategoryName") {
        this.upDowUpdateCategoryNameCSS = 'active';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "StateName") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = 'active';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "UpdateType") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = 'active';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "CreatedBy") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = 'active';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = 'active';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "ModifiedBy") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = 'active';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "ModifiedDate") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = 'active';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "UpdateDate") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = 'active';
      }
    }
    else {
      this.isAscending = false;
      this.parameterModel.orderBy = sortBy;

      if (sortBy === "UpdateCategoryName") {
        this.upDowUpdateCategoryNameCSS = 'active-up';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "StateName") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = 'active-up';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "UpdateType") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = 'active-up';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "CreatedBy") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = 'active-up';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = 'active-up';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "ModifiedBy") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = 'active-up';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "ModifiedDate") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = 'active-up';
        this.upDowUpdateDateCSS = '';
      }
      else if (sortBy === "UpdateDate") {
        this.upDowUpdateCategoryNameCSS = '';
        this.upDowStateCSS = '';
        this.upDowUpdateTypeCSS = '';
        this.upDowCreatedByCSS = '';
        this.upDowCreatedDateCSS = '';
        this.upDowModifiedByCSS = '';
        this.upDowModifiedDateCSS = '';
        this.upDowUpdateDateCSS = 'active-up';
      }
    }
    this.GetUpdates();
  }

  pageChanged($event) {
    this.parameterModel.pageIndex = parseInt($event.page);
    this.GetUpdates();
  }

  blockDocument() {
    this.isShowprogressSpinner = true;
    this.blockedDocument = true;
  }

  unblockDocument() {
    this.isShowprogressSpinner = false;
    this.blockedDocument = false;
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  movetotop() {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20); // how far to scroll on each step
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 1);
  }

  keywordFilters($event) {
    this.parameterModel.pageIndex = 1;
    if ($event.target.value != "" && $event.target.value != null)
      this.parameterModel.keywordFilter = $event.target.value;
    else
      this.parameterModel.keywordFilter = 'null';

    this.GetUpdates();
  }

  isupdatesDatesFilter(value: any) {
    this.parameterModel.pageIndex = 1;
    if (value != null) {
      if (value.length == 2) {
        this.parameterModel.pageIndex = 1;
        const d = new Date(value[0]);
        const a = [this.pad(d.getMonth() + 1), this.pad(d.getDate()), d.getFullYear()].join('/');

        const e = new Date(value[1]);
        const f = [this.pad(e.getMonth() + 1), this.pad(e.getDate()), e.getFullYear()].join('/');

        this.parameterModel.fromupdatesDateFilter = a;
        this.parameterModel.toupdatesDateFilter = f;
       this.GetUpdates();
      }
    }
  }

  pad(s) {
    return (s < 10) ? '0' + s : s;
  }

  updatesDateFilterClear() {
    this.rangeOfupdatesDates = [];
    this.parameterModel.fromupdatesDateFilter = "";
    this.parameterModel.toupdatesDateFilter = "";
    this.GetUpdates();
  }

  viewallupdates() {
        this.ipcsUnread=0;
    this.GetUpdates();
  }

  saveNotification(updates) {
    let _updates = updates;
    for (let iCounter = 0; iCounter < _updates.length; iCounter++) {
      _updates[iCounter].createdBy = this.userID.toString();
    }
    this.ipcsService.AddIIPCSNotification(_updates, this.tokenKey).subscribe(data => {
      if (data.status == 'Success') {
       sessionStorage.setItem('ipcsUnreadflag','true');
        sessionStorage.setItem('ipcsUnread','0');
      }
      else {
        this.showMessage(data.status, 'Error', 'error');
      }
    }, error => {
      this.showMessage(error, 'Error', 'error');
    });
  }

  updatetypechange($event) {
    this.parameterModel.pageIndex = 1;
    if ($event.target.checked) {
      if (this.parameterModel.updatetype == "-1") { this.parameterModel.updatetype = "" }
      if (this.parameterModel.updatetype == '' || this.parameterModel.updatetype == 'null') {
        this.parameterModel.updatetype = $event.target.value;
      }
      else {
        this.parameterModel.updatetype += ',' + $event.target.value;
      }
    }
    else {
      this.parameterModel.updatetype = this.parameterModel.updatetype.replace($event.target.value, "");
      this.parameterModel.updatetype = this.parameterModel.updatetype.replace(/,\s*$/, "");
      this.parameterModel.updatetype = this.parameterModel.updatetype.replace(",,", ",");
      if (this.parameterModel.updatetype.charAt(0) == ",") {
        this.parameterModel.updatetype = this.parameterModel.updatetype.slice(1)
      }
      if (this.parameterModel.updatetype == "") { this.parameterModel.updatetype = "-1" }
    }

    this.GetUpdates();
  }

  navigateToFundDetailByName(stateId: any, stateName: any, title: any, fieldName: any) {
    sessionStorage.setItem('singleStatePreview', stateId);
    sessionStorage.setItem('updatefunddata', title + ' - ' + fieldName);
    
    ApplicationActivityStore('View', 'IPCS PRO Updates - View History', this.appActivity, ToolEnum.ipcs, ActionActivity.IPCS, '/ipcs/Matrix/Fund/Details/', stateName);
    
    let navigation = '/' + this.ClientSelectedTool + '/Matrix/Fund/Details/' + stateName;
    this.router.navigate([navigation]);
  }

  pdfDocument() {
    this.blockDocument();
    let mainURL = this.baseUrl;
     let url = '<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"> '
    url += ' <link rel="stylesheet" href="' + mainURL + '/assets/css/bootstrap.min.css" asp-append-version="true" /> ';
    url += '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/AdminLTE.min.css"> ';
    url += '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/ionicons.min.css"> ';
    url += '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/jquery-jvectormap.css"> ';
    url += '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/_all-skins.min.css"> ';
    url += '<link id="adminstyle" rel="stylesheet" href="' + mainURL + '/assets/css/Admin/_all.css"> ';

    
    var html = url + document.getElementById('divPrint').innerHTML;
    this.htmlToPdf.CreatePDF(this.tokenKey, html, '0',this.productId).
      subscribe(data => {
        if (data['status'] == 'Success') {
          this.downloadFile('Update', data['url']);
        }
      },
        error => {
          this.statusCode = error;
          this.unblockDocument();
        }
      );
  }

  public downloadFile(filename, url) {
    this.htmlToPdf.downloadPdf(url).subscribe(
      (res) => {
        FileSaver.saveAs(res, filename);
        
        ApplicationActivityStore('Download', 'IPCS PRO Updates File download ' + filename, this.appActivity, ToolEnum.ipcs, ActionActivity.IPCS, '/ipcs/Update');
       
        sessionStorage.setItem('fileloading', 'false');
        this.unblockDocument();
      }
    );
  }

  GetStateData(): void {
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.ipcsService.GetIPCSMatrixFundState(this.tokenKey, this.userID).subscribe(
      data => {
        if (data["state"] != null) {
          // Set All Item
          for (let iCounter = 0; iCounter < data["state"].length; iCounter++) {
            this.dropdownListState.push(
              { "id": data["state"][iCounter].stateId, "itemName": data["state"][iCounter].name }
            );
          }
        }
        else {
          this.showMessage(data["message"], 'Error', 'error');
          this.unblockDocument();
        }
        this.dropdownSettingsState = {
          singleSelection: false,
          text: "Select State(s)",
          enableSearchFilter: false,
          classes: "borderLessTextBoxGreen",
          badgeShowLimit: 1,
          noDataLabel: 'No state available',
          showCheckbox: true,
          enableFilterSelectAll: false
        };
      }, error => {
        this.showMessage(error, 'Error', 'error');
        this.unblockDocument();
      })
  }

  FilterSelecteventState($event) {
    this.stateFilter = '';
    this.listOfstateID = this.removeElemetninArray(this.listOfstateID, $event['id']);
    this.listOfstateID.push($event.id);
    this.getString(this.listOfstateID);
    this.parameterModel.keywordFilter = this.stateFilter;
    this.GetUpdates();
  }

  FilterDeSelectseventState($event) {
    this.stateFilter = '';
    this.listOfstateID = this.removeElemetninArray(this.listOfstateID, $event['id']);
    this.getString(this.listOfstateID);
    this.parameterModel.keywordFilter = this.stateFilter;
    this.GetUpdates();
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e != element);
  }

  getString(array: any) {
    let sprator = '';
    this.stateFilter = '';
    for (let iCounter = 0; iCounter < array.length; iCounter++) {
      this.stateFilter += sprator + array[iCounter];
      sprator = ',';
    }
  }

  onSelectAllStateList($event) {
    this.stateFilter = '';
    if ($event != "" && $event != null) {
      for (let iCounter = 0; iCounter < $event.length; iCounter++) {
        this.listOfstateID = this.removeElemetninArray(this.listOfstateID, $event[iCounter].id);
        this.listOfstateID.push($event[iCounter].id);
      }
      this.getString(this.listOfstateID);
      this.parameterModel.keywordFilter = this.stateFilter;
    }
    this.GetUpdates();
  }

  onDeSelectAllStateList($event) {
    this.listOfstateID = [];
    this.stateFilter = '';
    this.parameterModel.keywordFilter = '';
    this.GetUpdates();
  }

  OpenActionStatusPopup(actionId: any, updateId: any, briefingId) {

    let prodid = ToolEnum.ipcs.toString();
    sessionStorage.setItem('productId', prodid);
    sessionStorage.setItem('actionId', actionId);
    sessionStorage.setItem('updateId', updateId);
    sessionStorage.setItem('briefingId', briefingId);
    const modalRef = this.modalService.open(ActionStatusPopupComponent, { size: 'lg' }).result.then(
      result => {
        if (result == 'Yes') {
          // this.GetDashboardActionItemsReuiredAttention();
        }
      },
      reason => {
      });
  }

  ngAfterViewInit() {
    this.setEmailAutoLoginParameter();
  }

  setEmailAutoLoginParameter() {
    if (sessionStorage.getItem('DisplayMessage') != null) {
      this.showMessage(sessionStorage.getItem('DisplayMessage') + ' - user not have access', 'Error', 'error');
      sessionStorage.removeItem('DisplayMessage');
    }
  }
}
